import { defineMessages, type MessageDescriptor } from 'react-intl';

export const reactionActorMessages: Record<'agentWithPerson', MessageDescriptor> = defineMessages({
	agentWithPerson: {
		id: 'reactions.actor.agent-with-person',
		defaultMessage: '{agentName} with {personName}',
		description: 'Name of the agent who reacted and the person who used the agent',
	},
});
